import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=ae7504a4&"
import script from "./TopBar.vue?vue&type=script&lang=js&"
export * from "./TopBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae7504a4')) {
      api.createRecord('ae7504a4', component.options)
    } else {
      api.reload('ae7504a4', component.options)
    }
    module.hot.accept("./TopBar.vue?vue&type=template&id=ae7504a4&", function () {
      api.rerender('ae7504a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TopBar.vue"
export default component.exports